<template>
  <div class="section">
    <div class="container">
      <h1>Audit log</h1>
      <div class="columns">
        <div class="column is-3">
          <b-field label="Start date">
            <b-datepicker v-model="dates.start" placeholder="Start Period" icon="calendar-day"></b-datepicker>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field label="End date">
            <b-datepicker v-model="dates.end" placeholder="End Period" icon="calendar-day"></b-datepicker>
          </b-field>
        </div>
      </div>
      <div>
        <FiltersVue ref="filterComp" v-model="filters"></FiltersVue>
      </div>
      <div class="breathe">
        <button @click="GetReport()" class="button is-primary level-item" v-bind:class="{'is-loading': loading}">Get report</button>
      </div>
      <br />
      <div class="columns">
        <div class="column is-12" v-if="rows.length > 0">
          <b-table :data="rows"
                   :loading="loading"
                   paginated
                   :mobile-cards="true"
                   pagination-size="is-small"
                   :pagination-simple="true"
                   per-page="20"
                   default-sort-direction="desc"
                   default-sort="Stamp">
            <b-table-column field="Action" label="Action" sortable v-slot="props">
              <div v-if="props.row.Action == 'Response'">
                <a @click="showChanges(props.row)">{{props.row.Action}}</a>
              </div>
              <div v-if="props.row.Action != 'Response'">
                {{props.row.Action}}
              </div>
            </b-table-column>
            <b-table-column field="Value" label="Description" sortable width="500" v-slot="props">
              <div id="Value" v-html="props.row.Value"></div>
            </b-table-column>
            <b-table-column field="Country" label="User Group" sortable width="200" v-slot="props">
              {{props.row.Country}}
            </b-table-column>
            <b-table-column field="Name" label="User" sortable width="200" v-slot="props">
              {{props.row.Name}}
            </b-table-column>
            <b-table-column field="Stamp" label="When" sortable width="300" v-slot="props">
              {{props.row.Stamp | utc | moment("MM/DD/YYYY h:mm:ss a")}} UTC<br />
              {{ props.row.Stamp | utc | moment("from") }}
            </b-table-column>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import FiltersVue from "@/services/components/Filters.vue";
  import showChanges from "@/components/modals/showChanges.vue";

  export default {
    components: {
      FiltersVue
    },
    data: function () {
      return {
        loading: false,
        dates: {},
        rows: [],
        filters: [],
        names: [],
        actions: [],
        countries: [],
        values: []
      }
    },
    methods: {
      async showChanges(change) {
        await this.$http.post("api/questionnaire/changes/question", { questionId: change.QuestionId, questionnaireId: change.QuestionnaireId, groupId: change.GroupId })
          .then(resp => {
            this.$buefy.modal.open({
              parent: this,
              component: showChanges,


              props: {
                changes: resp.data,
              },
            })
          }).catch(err => {
            console.error(err);
          })
      },
      GetReport() {
        this.loading = true;

        let selection = this.$refs.filterComp.selection;
        if (selection.key !== undefined && selection.value !== undefined) {
          this.$refs.filterComp.Add();
        }

        this.actions = [];
        this.countries = [];
        this.names = [];
        this.values = [];

        this.filters.forEach(filter => {
          if (filter.key == "Action") {
            filter.value.forEach(value => {
              this.actions.push(value);
            })
          } else if (filter.key == "Country") {
            filter.value.forEach(value => {
              this.countries.push(value);
            })
          } else if (filter.key == "Name") {
            filter.value.forEach(value => {
              this.names.push(value);
            })
          } else if (filter.key == "Value") {
            this.values.push(filter.value);
          }
        });

        this.$http.post("/api/report/audit", { dates: this.dates, actions: this.actions, countries: this.countries, names: this.names, values: this.values })
          .then(resp => {
            this.rows = resp.data;
            if (resp.data.length < 1) {
              this.$buefy.notification.open({ message: "There were 0 results for this search. Please change your filters and try again.", type: "is-danger" })
            }
            this.loading = false;
          }).catch(resp => {
            this.loading = false;
            this.$toast.open({
              message: "A problem occurred! Make sure fields are correct and try again.",
              type: "is-danger"
            });
          });
      }
    },
    mounted() {
      this.dates.end = new Date();
      this.dates.start = new Date();
      this.dates.start.setDate(this.dates.start.getDate() - 30);

      this.GetReport();
    }
  }
</script>

<style>
  #value {
    max-width: 400px !important;
  }
</style>
